import type { ImageSourcePropType } from "react-native"

// Import custom icons
const lineIcon = require("../../../assets/tvIcons/line_tv_black.png")
const sectionIcon = require("../../../assets/tvIcons/section_tv_black.png")
const towerIcon = require("../../../assets/tvIcons/tower_tv_black.png")
const towerTensionIcon = require("../../../assets/tvIcons/tower_tv_red.png")
const spanIcon = require("../../../assets/tvIcons/span_tv_black.png")

export const getNodeIcon = (type: string, properties?: Record<string, any>): ImageSourcePropType => {
  switch (type) {
    case "line":
      return lineIcon
    case "section":
      return sectionIcon
    case "tower":
      // Check if IsTension property is true
      return properties?.IsTension == true ? towerTensionIcon : towerIcon
    case "span":
      return spanIcon
    default:
      return towerIcon // Default fallback
  }
}

